/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 (function($) {


 	openModal = function() {
 		$('.open--modal').magnificPopup({
 			type: 'inline'
 		});
 	};

 	fluidVideo = function() {
 		$('iframe[src*="youtube"]').wrap('<div class="videoWrapper"></div>');
 		$('iframe[src*="vimeo"]').wrap('<div class="videoWrapper"></div>');
 	};

 	// scrollTop = function() {
 	// 	$('.scroll--top').on('click', function(e){
 	// 		e.preventDefault();
 	// 		$('html,body').animate({
 	// 			scrollTop: 0
 	// 		});
 	// 	});
 	// };

 	// scrollHomepage = function() {
 	// 	$('.scroll--vh').on('click', function(e){
 	// 		e.preventDefault();
 	// 		var videoheight = $('.hero').outerHeight(true);

 	// 		if ($(window).width() > 1149) {
 	// 			videoheight = $('.hero').outerHeight(true) - 82;
 	// 		}
 	// 		console.log('ja');

 	// 		$('html, body').animate({
 	// 			scrollTop: videoheight
 	// 		}, 500);  
 	// 	});
 	// };


 	clientSlider = function() {
 		$('.clientslider')
 		.slick({
 			dots: true,
 			customPaging : function(slider, i) {
 				return '<span></span>';
 			},
 			arrows: true,
 			nextArrow: '<div class="slick-arrow slick-right icon-arrow-right"></div>',
 			prevArrow: '<div class="slick-arrow slick-left icon-arrow-left"></div>',
 			lazyLoad: 'ondemand',
 			autoplaySpeed: 7000,
 			autoplay: false,
 			slidesToScroll: 1,
 			slidesToShow: 1,
 			infinite: false,
 			mobileFirst: true,
 			adaptiveHeight: false,
 			responsive: [
 			{
 				breakpoint: 700,
 				settings: {
 					slidesToScroll: 1,
 					slidesToShow: 2
 				}
 			},
 			{
 				breakpoint: 1024,
 				settings: {
 					slidesToScroll: 1,
 					slidesToShow: 4
 				}
 			}
 			],
 			cssEase: 'linear'
 		})
 		.show();
 	};


 	mobileSlider = function() {
 		$('.mobileslider')
 		.slick({
 			dots: false,
 			arrows: true,
 			nextArrow: '<div class="slick-arrow slick-right icon-arrow-right"></div>',
 			prevArrow: '<div class="slick-arrow slick-left icon-arrow-left"></div>',
 			lazyLoad: 'ondemand',
 			autoplaySpeed: 7000,
 			autoplay: false,
 			slidesToScroll: 1,
 			slidesToShow: 1,
 			infinite: true,
 			mobileFirst: true,
 			adaptiveHeight: false,
 			responsive: [
 			{
 				breakpoint: 700,
 				settings: {
 					slidesToScroll: 1,
 					slidesToShow: 3
 				}
 			}
 			],
 			cssEase: 'linear'
 		})
 		.show();
 	};

 	scrollHomepage = function() {
 		$('.scroll--vh').on('click', function(e){
 			e.preventDefault();
 			// var vheight = $(window).height();
 			// var headerheight = $('.header').height();
 			var heroHeight = $('.hero').height();

 			$('html, body').animate({
 				scrollTop: heroHeight
 			}, 500);  
 		});
 	};


 	/*----------  Product detailpage  ----------*/
 	// newsSlider = function() {

 	// 	$('.newsslider-for').slick({
 	// 		slidesToShow: 1,
 	// 		slidesToScroll: 1,
 	// 		arrows: true,
 	// 		adaptiveHeight: false,
 	// 	// 	autoplay: true,
		// 	// autoplaySpeed: 5000,
		// 	infinite: true,
		// 	rows: 0,
		// 	fade: true,
		// 	nextArrow: '<div class="slick-arrow slick-right icon-arrow-right-light"></div>',
		// 	prevArrow: '<div class="slick-arrow slick-left icon-arrow-left-light"></div>',
		// 	asNavFor: '.newsslider-nav'
		// });

 	// 	$('.newsslider-nav').slick({
 	// 		slidesToShow: 4,
 	// 		slidesToScroll: 1,
 	// 		asNavFor: '.newsslider-for',
 	// 		dots: false,
 	// 		rows: 0,
 	// 		infinite: true,
 	// 		centerMode: false,
 	// 		arrows: false,
 	// 		vertical: true,
 	// 		adaptiveHeight: false,
 	// 		focusOnSelect: true
 	// 	});

	 // 	// ticking machine
	 // 	var percentTime;
	 // 	var tick;
	 // 	var time = 1;
	 // 	var progressBarIndex = 0;

	 // 	$('.newsslider-nav .newsnav__progress').each(function(index) {
	 // 		var progress = "<span class='inprogress" + index + "'></span>";
	 // 		$(this).html(progress);
	 // 	});

	 // 	function startProgressbar() {
	 // 		resetProgressbar();
	 // 		percentTime = 0;
	 // 		tick = setInterval(interval, 10);
	 // 	}

	 // 	function interval() {
	 // 		if (($('.newsitem[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
	 // 			progressBarIndex = $('.newsitem[aria-hidden="false"]').data("slickIndex");
	 // 			startProgressbar();
	 // 		} else {
	 // 			percentTime += 1 / (time + 4);
	 // 			$('.inprogress' + progressBarIndex).css({
	 // 				width: percentTime + "%"
	 // 			});
	 // 			if (percentTime >= 100) {
	 // 				$('.newsslider-for').slick('slickNext');
	 // 				progressBarIndex++;
	 // 				if (progressBarIndex > 3) {
	 // 					progressBarIndex = 0;
	 // 				}
	 // 				startProgressbar();
	 // 			}
	 // 		}
	 // 	}

	 // 	function resetProgressbar() {
	 // 		$('.newsnav__progress span').css({
	 // 			width: 0 + '%'
	 // 		});
	 // 		clearInterval(tick);
	 // 	}

	 // 	startProgressbar();

	 // 	$('.newsslider-nav .newsnav').click(function () {
	 // 		clearInterval(tick);
	 // 		var goToThisIndex = $(this).data("slickIndex");
	 // 		$('.newsslider-for').slick('slickGoTo', goToThisIndex, false);
	 // 		startProgressbar();
	 // 	});

	 // };

	 /*----------  Open image url`s in popup  ----------*/
	 // showImageModal = function() {
	 // 	$('.content__content a').each(function(i, el) {
	 // 		if(! $(this).parents().hasClass('gallery--wrapper')) {
	 // 			var href_value = el.href;
	 // 			if (/\.(jpg|png|gif)$/.test(href_value)) {
	 // 				$(this).magnificPopup({
	 // 					type: 'image',
	 // 					closeOnContentClick: true,
	 // 					mainClass: 'mfp-img-mobile',
	 // 					image: {
	 // 						verticalFit: true
	 // 					}
	 // 				});
	 // 			} 
	 // 		}
	 // 	});

	 // 	$('.gallery--wrapper ul').each(function(i, el) {
	 // 		$(this).magnificPopup({
	 // 			delegate: 'a', /* the selector for gallery item */
	 // 			type: 'image',
	 // 			gallery: {
	 // 				enabled:true
	 // 			}
	 // 		});
	 // 	});

	 // 	$('.thumbs').each(function(i, el) {
	 // 		$(this).magnificPopup({
	 // 			delegate: 'a', /* the selector for gallery item */
	 // 			type: 'image',
	 // 			gallery: {
	 // 				enabled:true
	 // 			}
	 // 		});
	 // 	});
	 // }

	 // contentGallery = function() {
	 // 	$('.gallery--wrapper ul').slick({
 	// 		dots: false,
 	// 		infinite: true,
 	// 		slidesToShow: 1,
 	// 		arrows: true,
 	// 		adaptiveHeight: false,
 	// 		nextArrow: '<div class="slick-arrow slick-right icon-arrow-right-light"></div>',
		// 	prevArrow: '<div class="slick-arrow slick-left icon-arrow-left-light"></div>',
 	// 		autoplay: true,
 	// 		autoplaySpeed: 7000,
 	// 		fade: true,
 	// 		slidesToScroll: 1,
 	// 		cssEase: 'linear'
 	// 	});
	 // }

	 floatLabels = function() {
	 	new FloatLabels( '.gform_wrapper',{
	 		customEvent  : null,
	 		customLabel  : null,
	 		exclude      : '.no-label',
	 		inputRegex   : /email|number|password|search|tel|text|url/,
		    prioritize   : 'label', // label|placeholder
		    requiredClass: 'required',
		    style        : 2, // 0|1|2
		    transform    : 'input,select,textarea'
		});
	 };

	 jQuery(document).bind('gform_post_render', function(){
	 	floatLabels();
	 });

	 /*----------  On scroll  ----------*/
	 $(window).scroll(function() {
 		// stickyNavigation();
 	});

	 /*----------  On resize  ----------*/
	 var waitForFinalEvent = (function () {
	 	var timers = {};
	 	return function (callback, ms, uniqueId) {
	 		if (!uniqueId) {
	 			uniqueId = "Don't call this twice without a uniqueId";
	 		}
	 		if (timers[uniqueId]) {
	 			clearTimeout (timers[uniqueId]);
	 		}
	 		timers[uniqueId] = setTimeout(callback, ms);
	 	};
	 })();

	 $(window).resize(function() {
	 	waitForFinalEvent(function(){
 			// s.refresh();
 		}, 500);
	 });


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
    	init: function() {
        // JavaScript to be fired on all pages
        // stickyNavigation();
        toggleNavigation();

        floatLabels();
        fluidVideo();

        // showImageModal();
        // contentGallery();

        mobileSlider();
        openModal();
        // scrollTop();

        // scrollHomepage();
        // newsSlider();
    },
    finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    }
},
    // Contact page
    'home': {
    	init: function() {
        // JavaScript to be fired on the home page
        clientSlider();
        scrollHomepage();
    },
    finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
    }
},
    // Contact page
    'page_template_contact_template': {
    	init: function() {
    		// initMap();
        // JavaScript to be fired on the home page
    },
    finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
    }
}
};

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
  	fire: function(func, funcname, args) {
  		var fire;
  		var namespace = Sage;
  		funcname = (funcname === undefined) ? 'init' : funcname;
  		fire = func !== '';
  		fire = fire && namespace[func];
  		fire = fire && typeof namespace[func][funcname] === 'function';

  		if (fire) {
  			namespace[func][funcname](args);
  		}
  	},
  	loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
      	UTIL.fire(classnm);
      	UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
  }
};

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
